import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, resetKey: 0 };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log for developer console; production APM (Sentry) can be wired later.
    console.warn("[ErrorBoundary]", error?.message || error, info?.componentStack?.slice(0, 240));
  }

  handleContinue = () => {
    // Soft reset: remount children with a fresh key, keep session cookie intact.
    this.setState((s) => ({ hasError: false, error: null, resetKey: s.resetKey + 1 }));
  };

  handleReload = () => {
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return (
        <React.Fragment key={this.state.resetKey}>{this.props.children}</React.Fragment>
      );
    }

    return (
      <div
        className="min-h-screen bg-white text-zinc-900 grid place-items-center px-6"
        data-testid="error-boundary"
      >
        <div className="max-w-md w-full text-center">
          <div className="mx-auto h-14 w-14 grid place-items-center bg-red-50 text-red-600 rounded-sm border border-red-200 mb-6">
            <AlertTriangle className="h-6 w-6" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight mb-2">
            Küçük bir aksama oldu
          </h1>
          <p className="text-sm text-zinc-600 leading-relaxed mb-6">
            Verileriniz güvende. Aşağıdaki "Devam et" butonuyla oturumunuzu
            kaybetmeden çalışmaya devam edebilirsiniz.
          </p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <button
              type="button"
              onClick={this.handleContinue}
              className="inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm px-4 py-2 rounded-sm font-semibold"
              data-testid="error-continue-btn"
            >
              Devam et
            </button>
            <button
              type="button"
              onClick={this.handleReload}
              className="inline-flex items-center justify-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-zinc-900 text-sm px-4 py-2 rounded-sm"
              data-testid="error-reload-btn"
            >
              <RefreshCw className="h-4 w-4" />
              Sayfayı Yenile
            </button>
          </div>
          {this.state.error && (
            <details className="mt-6 text-left text-xs text-zinc-500 bg-zinc-50 border border-zinc-200 rounded-sm p-3">
              <summary className="cursor-pointer text-zinc-600 font-medium">
                Teknik detay
              </summary>
              <pre className="mt-2 whitespace-pre-wrap break-words font-mono text-[11px] text-zinc-500">
                {String(this.state.error?.message || this.state.error)}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
